import { PaymentReceiversService_paymentReceiverServiceGetGetAtEvent } from '@festina/moneyout-general-types/moneyout/hooks/PaymentReceiversService_paymentReceiverServiceGetGetAtEvent'

export const useFetchPaymentReceiverVersionByEventId =
  PaymentReceiversService_paymentReceiverServiceGetGetAtEvent.useSuspenseQuery
